import { render, staticRenderFns } from "./StatementSettingsView.vue?vue&type=template&id=1355dd1c&scoped=true"
import script from "./StatementSettingsView.vue?vue&type=script&lang=js"
export * from "./StatementSettingsView.vue?vue&type=script&lang=js"
import style0 from "./StatementSettingsView.vue?vue&type=style&index=0&id=1355dd1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1355dd1c",
  null
  
)

export default component.exports